
export default [
    {
        title: "No",
        size: 1
    },
    {
        title: "Name",
        size: 4
    },
    {
        title: "Sumber Data",
        size: 3
    },
    {
        title: "Aksi",
        size: 3
    },
];